var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleClick}},[_c('span',{staticClass:"index",style:({
    backgroundColor: _vm.color,
    color: _vm.textColor
  })},[_vm._v(" "+_vm._s(_vm.$gettext(_vm.text))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }